export const getFloatingNumber = (num) => parseFloat(num.toFixed(2));
